module.exports = {
	DOMParser: require('./dom/DOMParser').DOMParser,
	DOMTreeBuilder: require('./dom/DOMTreeBuilder').DOMTreeBuilder,
	JSDOMParser: require('./jsdom/JSDOMParser').JSDOMParser,
	JSDOMTreeBuilder: require('./jsdom/JSDOMTreeBuilder').JSDOMTreeBuilder,
	SAXParser: require('./sax/SAXParser').SAXParser,
	SAXTreeBuilder: require('./sax/SAXTreeBuilder').SAXTreeBuilder,
	Tokenizer: require('./Tokenizer').Tokenizer
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/html5/lib/index.js
// module id = 18
// module chunks = 0